import { SpyneTrait, ViewStream } from 'spyne';
import { ContactUsView } from 'components/page-items/contact-us-view.js';

export class PageItemCustomTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = 'pageItem$';
    super(context, traitPrefix);
  }

  static pageItem$HelloWorld() {
    return 'Hello World';
  }

  static pageItem$GetViewClass(viewClass="ViewStream"){
    const classLookup = {
      ContactUsView,
    }
    return  classLookup[viewClass] || ViewStream;

  }
}
